e360.filter('unsafe', [
   '$sce',

   function ($sce) {
      return function (input) {
         return $sce.trustAsHtml(input ? input.toString() : '');
      };
   }
]);